import { SET_WARRANTY_SETTINGS_DATA_LOADING, SET_WARRANTY_SETTINGS_DATA, SET_WARRANTY_PERIODS_DATA, CLEAR_WARRANTY_SETTINGS_DATA } from './types';
import store from '../../../../store';
import Axios from '../../../../common/util/Axios';

export const findWarrantySettings = () => async (dispatch) => {
  try {
    dispatch({ type: SET_WARRANTY_SETTINGS_DATA_LOADING, payload: true });

    const companyId = store.getState().authState.companyId;
    const queryParams = {
      companyId,
    };
    if (!companyId) {
      return false;
    }
    
    const res = await Axios.get('/api/dashboard/settings/find-warranty-settings', {
      params: queryParams,
    });
    dispatch({
      type: SET_WARRANTY_SETTINGS_DATA,
      payload: res.data.data || [],
    });

    return true;
  } catch (error) {
    dispatch({
      type: SET_WARRANTY_SETTINGS_DATA,
      payload: [],
    });
    return false;
  }
};

export const findWarrantyPeriods = () => async (dispatch) => {
  try {
    dispatch({ type: SET_WARRANTY_SETTINGS_DATA_LOADING, payload: true });

    const companyId = store.getState().authState.companyId;
    const queryParams = {
      companyId,
    };
    if (!companyId) {
      return false;
    }
    
    const res = await Axios.get('/api/dashboard/settings/find-warranty-periods', {
      params: queryParams,
    });
    dispatch({
      type: SET_WARRANTY_PERIODS_DATA,
      payload: res.data.data || [],
    });

    return true;
  } catch (error) {
    dispatch({
      type: SET_WARRANTY_PERIODS_DATA,
      payload: [],
    });
    return false;
  }
};

export const updateWarrantySettings = (warrantySettings) => async (dispatch) => {
  try {
    dispatch({ type: SET_WARRANTY_SETTINGS_DATA_LOADING, payload: true });

    const companyId = store.getState().authState.companyId;
    const requestBody = {
      ...warrantySettings.warrantySettingsData,
    };

    const queryParams = {
      companyId,
      branchId: warrantySettings.branchId,
    };

    const res = await Axios.post(`/api/dashboard/settings/update-warranty-settings`, requestBody, {
      params: queryParams,
    });
    dispatch({ type: SET_WARRANTY_SETTINGS_DATA_LOADING, payload: false });
    return true;
  } catch (err) {
    dispatch({ type: SET_WARRANTY_SETTINGS_DATA_LOADING, payload: false });
    return false;
  }
};

export const createWarrantyPeriod = (warrantyPeriod) => async (dispatch) => {
  try {
    dispatch({ type: SET_WARRANTY_SETTINGS_DATA_LOADING, payload: true });

    const companyId = store.getState().authState.companyId;
    const branchId = store.getState().authState.branchId;
    
    const requestBody = {
      ...warrantyPeriod,
    };

    const queryParams = {
      companyId,
      branchId,
    };

    const res = await Axios.post(`/api/dashboard/settings/create-warranty-period`, requestBody, {
      params: queryParams,
    });
    dispatch({ type: SET_WARRANTY_SETTINGS_DATA_LOADING, payload: false });
    return res.data.success;
  } catch (err) {
    dispatch({ type: SET_WARRANTY_SETTINGS_DATA_LOADING, payload: false });
    return false;
  }
};

export const updateWarrantyPeriod = (warrantyPeriod, periodId) => async (dispatch) => {
  try {
    dispatch({ type: SET_WARRANTY_SETTINGS_DATA_LOADING, payload: true });

    const companyId = store.getState().authState.companyId;
    const branchId = store.getState().authState.branchId;
    
    const requestBody = {
      id: periodId,
      ...warrantyPeriod,
    };

    const queryParams = {
      companyId,
      branchId,
      periodId,
    };

    const res = await Axios.post(`/api/dashboard/settings/update-warranty-period`, requestBody, {
      params: queryParams,
    });
    dispatch({ type: SET_WARRANTY_SETTINGS_DATA_LOADING, payload: false });
    return res.data.success;
  } catch (err) {
    dispatch({ type: SET_WARRANTY_SETTINGS_DATA_LOADING, payload: false });
    return false;
  }
};

export const deleteWarrantyPeriod = (periodId) => async (dispatch) => {
  try {
    dispatch({ type: SET_WARRANTY_SETTINGS_DATA_LOADING, payload: true });

    const companyId = store.getState().authState.companyId;
    const branchId = store.getState().authState.branchId;
    const queryParams = {
      companyId,
      branchId,
      periodId,
    };

    const res = await Axios.delete(`/api/dashboard/settings/delete-warranty-period`, {
      params: queryParams,
    });
    dispatch({ type: SET_WARRANTY_SETTINGS_DATA_LOADING, payload: false });
    return res.data.success;
  } catch (err) {
    dispatch({ type: SET_WARRANTY_SETTINGS_DATA_LOADING, payload: false });
    return false;
  }
};

